import { SHOW_AUTOCOMPLETE_TOGGLER } from 'ACTIONS';

export const toggleShowAutocomplete = (payload = false) => (dispatch) => {
    dispatch({ type: SHOW_AUTOCOMPLETE_TOGGLER, payload });
};
